module.exports = __webpack_public_path__ + "static/media/location-map-flat.80b34f02.svg";